<template>
	<div class="portalCms-addColumn">
		<div class="portalCms-addColumn-header">
			<span>{{ title }}</span>
			<div style="flex: 1"></div>
			<!-- <el-button @click="$router.push({ name: 'Column' })">返回</el-button> -->
		</div>
		<el-form :model="cmsColumn" :rules="cmsColumnRules" ref="cmsColumn" label-width="110px" class="portalCms-addColumn-form" :elValidator="type">
			<el-form-item label="栏目类型" prop="columnType">
				<el-select v-model="cmsColumn.columnType" placeholder="请选择栏目类型">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="栏目名称" prop="columnName"><el-input v-model="cmsColumn.columnName" placeholder="请输入栏目名称"></el-input></el-form-item>
			<el-form-item label="栏目链接" v-if="cmsColumn.columnType != 2" prop="columnUrl"><el-input v-model="cmsColumn.columnUrl" placeholder="请输入栏目链接"></el-input></el-form-item>
			<el-form-item label="排序号" prop="columnOrder"><el-input v-model="cmsColumn.columnOrder" placeholder="请输入栏目排序号"></el-input></el-form-item>
			
			<el-form-item label="数据源类型" prop="dataType" v-if="cmsColumn.columnType == 2">
				<el-select v-model="cmsColumn.dataType" placeholder="请选择数据源类型">
					<el-option label="mySql" value="mySql"></el-option>
					<el-option label="oracle" value="oracle"></el-option>
					<el-option label="sqlServe" value="sqlServe"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="数据源地址" prop="dataUrl" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataUrl" placeholder="请输入数据源地址"></el-input></el-form-item>
			<el-form-item label="数据源端口" prop="dataPort" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataPort" placeholder="请输入数据源端口"></el-input></el-form-item>
			<el-form-item label="数据库实例" prop="dataExample" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataExample" placeholder="请输入数据库实例"></el-input></el-form-item>
			<el-form-item label="数据库用户名" prop="dataUser" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataUser" placeholder="请输入数据库用户名"></el-input></el-form-item>
			<el-form-item label="数据库密码" prop="dataPassword" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataPassword" placeholder="请输入数据库密码"></el-input></el-form-item>
			<el-form-item label="查询sql语句" prop="dataSql" v-if="cmsColumn.columnType == 2"><el-input v-model="cmsColumn.dataSql" type="textarea" placeholder="请输入查询sql语句"></el-input></el-form-item>
				
			<!-- <el-form-item label="栏目图标" prop="iconUrl">
				<el-upload
					class="avatar-uploader"
					:action="uploadUrl"
					:show-file-list="false"
					accept=".jpg, .jpeg, .png"
					:before-upload="beforeUpload"
					:http-request="param => onRequest(param, cmsColumn)"
				>
					<template v-if="cmsColumn.iconUrl">
						<img :src="cmsColumn.iconUrl" class="avatar" />
					</template>
					<template v-else>
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</template>
				</el-upload>
			</el-form-item>
			<el-form-item label="栏目模版" prop="templateId">
				<el-select v-model="cmsColumn.templateId" placeholder="请选择栏目模版">
					<el-option v-for="list in columnTemplateList" :key="list.id" :label="list.fileName" :value="list.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="栏目描述" prop="columnDesc"><el-input type="textarea" v-model="cmsColumn.columnDesc"></el-input></el-form-item>
			<el-form-item label="是否强制订阅" prop="subscription"><el-switch v-model="cmsColumn.subscription" active-value="1" inactive-value="0"></el-switch></el-form-item>
			<el-form-item label="是否公开访问" prop="publicAccess"><el-switch v-model="cmsColumn.publicAccess" active-value="1" inactive-value="0"></el-switch></el-form-item>
			<el-form-item label="可浏览部门" v-if="cmsColumn.publicAccess === '0'">
				<el-select
					v-model="cmsColumn.itemDept"
					placeholder="请选择可浏览部门"
					@visible-change="DrawerTreeVisible = true"
					multiple
					collapse-tags
					popper-class="portalCms-addColumn-userOrgSelect"
				>
					<el-option v-for="item in cmsColumn.itemDept" :key="item.id" :label="item.name" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="可浏览角色" v-if="cmsColumn.publicAccess === '0'" prop="viewRoles">
				<el-select v-model="cmsColumn.viewRoles" placeholder="请选择可浏览角色" multiple>
					<el-option v-for="list in RoleTree" :key="list.id" :label="list.name" :value="list.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="可浏览用户组" v-if="cmsColumn.publicAccess === '0'" prop="viewGroups">
				<el-select v-model="cmsColumn.viewGroups" placeholder="请选择可浏览用户组" multiple>
					<el-option v-for="list in GroupTree" :key="list.id" :label="list.name" :value="list.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否需要审核" prop="needReview"><el-switch v-model="cmsColumn.needReview" active-value="1" inactive-value="0"></el-switch></el-form-item>
			<el-form-item label="审核流程" v-if="cmsColumn.needReview === '1'" prop="flowId">
				<el-select v-model="cmsColumn.flowId" placeholder="请选择审核流程">
					<el-option v-for="item in workConList" :key="item.id" :label="item.ff_name" :value="item.id"></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item>
				<el-button type="primary" @click="submitForm('cmsColumn')">保存</el-button>
				<el-button @click="resetForm('cmsColumn')">重置</el-button>
			</el-form-item>
		</el-form>
		<!-- 部门选择 -->
		<!-- <el-drawer :visible.sync="DrawerTreeVisible" direction="rtl" size="600px">
			<DrawerTree :baseUserUrl="baseUserUrl" @choose="chooseOrg" :request="request" :data.sync="cmsColumn.itemDept" :id="viewDepts" department />
		</el-drawer> -->
	</div>
</template>

<script>
import { submitForm, getOneColumn } from '@/api/cms-api';
import { mapGetters } from 'vuex';
export default {
	name: 'addColumn',
	computed: {
		...mapGetters(['request'])
	},
	data() {
		return {
			// 新增栏目
			title: '新增栏目',
			type: true,
			options: [{
				value: '1',
				label: 'RSS'
			},
			{
				value: '2',
				label: '数据库'
			},{
				value: '3',
				label: 'webService'
			}],
			
			// 栏目id
			columnId: "",
			// 表单列表
			cmsColumn: {
				// 栏目类型
				columnType: '',
				// 栏目名称
				columnName: '',
				columnUrl: '',
				columnOrder:  '',
				dataType: '',
				dataUrl: '',
				dataPort: '',
				dataExample: '',
				dataUser: '',
				dataPassword: '',
				dataSql: ''
			},
			// 表单校验
			cmsColumnRules: {
				columnUrl: [{ required: true, message: '请输入栏目链接', trigger: 'blur' }],
				columnName: [{ required: true, message: '请输入栏目名称', trigger: 'blur' }],
				columnOrder: [{ required: true, message: '请输入栏目排序号', trigger: 'blur' }],
				columnType: [{ required: true, message: '请选择栏目类型', trigger: 'change' }],
				dataType: [{ required: true, message: '请选择数据源类型', trigger: 'change' }],
				dataUrl: [{  required: true, message: '请输入数据源地址', trigger: 'blur' }],
				dataUser: [{ required: true, message: '请输入数据库用户名', trigger: 'blur' }],
				dataPassword: [{ required: true, message: '请输入数据库密码', trigger: 'blur' }],
				dataSql: [{ required: true, message: '请输入查询sql语句', trigger: 'blur' }],
				dataPort:[{ required: true, message: '请输入数据源端口', trigger: 'blur' }],
				dataExample: [{ required: true, message: '请输入数据库实例', trigger: 'blur' }]
			},
		};
	},
	created() {
		this.baseUserUrl = process.env.VUE_APP_REQUEST_ADMIN_BASE_URL;
	},
	mounted() {
		if (this.$route.params.colId) {
			this.title = '修改栏目';
			this.columnId = this.$route.params.colId;
			this.handleOneColumn();
		}
	},
	methods: {
		
		// 提交表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let cmsColumn = JSON.parse(JSON.stringify(this.cmsColumn));
					console.log('cmsColumn', cmsColumn);
					let data = {}
					if(this.columnId){
						data = {
							id: this.columnId,
							columnType: cmsColumn.columnType,
							columnName: cmsColumn.columnName,
							columnUrl: cmsColumn.columnUrl,
							columnOrder: cmsColumn.columnOrder,
							dataType: cmsColumn.dataType,
							dataUrl: cmsColumn.dataUrl,
							dataPort: cmsColumn.dataPort,
							dataExample: cmsColumn.dataExample,
							dataUser: cmsColumn.dataUser,
							dataPassword: cmsColumn.dataPassword,
							dataSql: cmsColumn.dataSql
						};
					}else{
						data = {
							columnType: cmsColumn.columnType,
							columnName: cmsColumn.columnName,
							columnUrl: cmsColumn.columnUrl,
							columnOrder: cmsColumn.columnOrder,
							dataType: cmsColumn.dataType,
							dataUrl: cmsColumn.dataUrl,
							dataPort: cmsColumn.dataPort,
							dataExample: cmsColumn.dataExample,
							dataUser: cmsColumn.dataUser,
							dataPassword: cmsColumn.dataPassword,
							dataSql: cmsColumn.dataSql
						};
					}
					submitForm(data).then((res) => {
						if (res.code === 0) {
							this.$message({
								message: "保存成功",
								type: "success",
							});
							this.$router.push({ name: "Column" });
						} else {
							this.$message.error(res.message);
						}
					})
					
				} else {
					return false;
				}
			});
		},
		// 根据id查询栏目内容 进行编辑
		handleOneColumn() {
			let data = {
				columnId: this.columnId
			};
			getOneColumn(data).then((res) => {
				console.log(res.data);
				this.cmsColumn.columnType = res.data.columnType;
				this.cmsColumn.columnName = res.data.columnName;
				this.cmsColumn.columnUrl = res.data.columnUrl;
				this.cmsColumn.columnOrder = res.data.columnOrder;
				this.cmsColumn.dataType = res.data.dataType;
				this.cmsColumn.dataUrl = res.data.dataUrl;
				this.cmsColumn.dataPort = res.data.dataPort;
				this.cmsColumn.dataExample = res.data.dataExample;
				this.cmsColumn.dataUser = res.data.dataUser;
				this.cmsColumn.dataPassword = res.data.dataPassword;
				this.cmsColumn.dataSql = res.data.dataSql;
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
	}
};
</script>

<style lang="scss" scoped>
.portalCms-addColumn {
	padding: 16px 20px 0;
	&-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 35px;
	}
	&-form {
		.el-select,
		.el-input,
		.el-textarea {
			width: 450px;
		}
	}
	&-userOrgSelect {
		display: none !important;
	}
	// element 添加图标css
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	// .el-drawer__body{
	//   height: 80vh;
	// }
	.DrawerTree {
		height: 80vh;
	}
}
</style>